<p-dialog [visible]="visible" (visibleChange)="$event ? null : close()" [modal]="true" [maximizable]="true" [draggable]="false"
	[closeOnEscape]="!selected" [style]="{ width: '90vw', height: '88vh' }" [contentStyle]="{ padding: '0 1.5rem 1.25rem' }"
	header="Inbox previews" styleClass="inbox-preview-dialog">

	<div class="loading" *ngIf="loading"><i class="pi pi-spin pi-spinner"></i> Loading…</div>

	<div class="not-configured" *ngIf="!loading && state && !state.configured">
		Inbox previews aren't set up on this server (no Mailgun Inspect API key).
	</div>

	<ng-container *ngIf="!loading && state?.configured">
		<!-- Run bar: who to render as, what it costs, and the button that spends previews. -->
		<div class="run-bar">
			<label for="inbox-preview-employer">Preview as</label>
			<div class="run-row">
				<p-dropdown inputId="inbox-preview-employer" [options]="employers" [(ngModel)]="employerID" optionLabel="employerName" optionValue="employerID"
					[filter]="true" filterBy="employerName" placeholder="Choose an employer…" [autoDisplayFirst]="false" appendTo="body" [style]="{ width: '280px' }"></p-dropdown>
				<div class="button success" [class.is-disabled]="!employerID || running || unsavedChanges" (click)="runPreview()">
					<i class="pi pi-spin pi-spinner" *ngIf="running"></i>{{ run ? 'Run again' : 'Run previews' }}
				</div>
				<span class="cost">Uses {{ state.clientsPerRun }} previews (one per mail app).</span>
			</div>
		</div>

		<div class="notice warn" *ngIf="unsavedChanges">You have unsaved changes. Previews use the saved email, so save first, then run.</div>
		<div class="notice error" *ngIf="error">{{ error }}</div>

		<div class="empty" *ngIf="!run && !running">
			No previews yet. Choose an employer and click <b>Run previews</b> to see this email in {{ state.clientsPerRun }} mail apps: Outlook, Gmail and Apple Mail,
			on desktop and phone, in light and dark mode. Results take a minute or two.
		</div>

		<ng-container *ngIf="run">
			<div class="run-info">
				<span>Taken {{ run.createdDate + 'Z' | date: 'MMM d, h:mm a' }} as <b>{{ run.employerName }}</b></span>
				<span class="badge outdated" *ngIf="run.isOutdated" pTooltip="The email was saved with changes after these previews were taken.">Email changed since</span>
				<span class="progress" *ngIf="!run.isFinished"><i class="pi pi-spin pi-spinner"></i> {{ doneCount }} of {{ run.clients.length }} ready</span>
			</div>

			<!-- Grid of mail apps -->
			<ng-container *ngIf="!selected">
				<div class="filters">
					<p-selectButton [options]="deviceOptions" [(ngModel)]="deviceFilter" optionLabel="label" optionValue="value" [allowEmpty]="false"></p-selectButton>
					<p-selectButton [options]="modeOptions" [(ngModel)]="modeFilter" optionLabel="label" optionValue="value" [allowEmpty]="false"></p-selectButton>
				</div>
				<div class="grid">
					<div class="tile" *ngFor="let c of clients" [class.clickable]="c.status === 'Complete'" (click)="open(c)">
						<div class="shot" [class.dark]="c.darkMode">
							<img *ngIf="c.status === 'Complete' && c.thumbnailUrl" [src]="c.thumbnailUrl" [alt]="c.displayName" loading="lazy" />
							<div class="state" *ngIf="isWorking(c)"><i class="pi pi-spin pi-spinner"></i> Rendering…</div>
							<div class="state failed" *ngIf="isFailed(c)"><i class="pi pi-exclamation-triangle"></i> Couldn't render ({{ c.status }})</div>
						</div>
						<div class="label">
							<div class="name">{{ c.displayName }}</div>
							<div class="meta">{{ isPhone(c) ? 'Phone' : 'Desktop' }} · {{ c.darkMode ? 'Dark' : 'Light' }} · {{ c.os }}</div>
						</div>
					</div>
				</div>
			</ng-container>

			<!-- One screenshot, full size -->
			<div class="viewer" *ngIf="selected">
				<div class="viewer-bar">
					<span class="back" (click)="selected = null"><i class="pi pi-arrow-left"></i> All mail apps</span>
					<span class="title">{{ selected.displayName }} <span class="meta">· {{ isPhone(selected) ? 'Phone' : 'Desktop' }} · {{ selected.darkMode ? 'Dark' : 'Light' }} · {{ selected.os }}</span></span>
					<span class="nav">
						<i class="pi pi-chevron-left" (click)="step(-1)" pTooltip="Previous (←)"></i>
						<i class="pi pi-chevron-right" (click)="step(1)" pTooltip="Next (→)"></i>
					</span>
				</div>
				<div class="viewer-image" [class.dark]="selected.darkMode">
					<img [src]="selected.screenshotUrl" [alt]="selected.displayName" />
				</div>
			</div>
		</ng-container>
	</ng-container>
</p-dialog>
